export const routes = {
  LOGIN: "/login",
  LOGOUT: "/logout",
  ACTIVITY: "/activity",
  STUDENT: "/student",
  TEACHER: "/teacher",
  MEMORAMA: "/games/memorama",
  WORD_SEARCH: "/games/wordsearch",
  CROSSWORDS: "/games/wordcross",
  GAMES: "/smashgames",
  GRADES: "/grades",
  CHOOSE_GAMES: "/choosegames",
  GROUPS: "/groups",
  PLACEMENTS: "/placements",
  TEACHER_GRADES: "/teacherGrades",
  MISSIONS: "/missions",
  MISSIONS_OLD: "/oldMissions",
  WORDS_EMOJI: "/games/wordsemoji",
  ACCOUNT: "/account",
  TICKETS: "/tickets",
  AVATAR: "/avatar",
  MY_AVATAR: "/avatar/myavatar",
  AVATAR_PIECE: "/avatar/piece",
  REWARDS: "/rewards",
  REDWARDS_ITEM: "/rewards/item",
  ONBOARDING: "/onboarding",
  PLACEMENTS_LEVEL: "/placements/level",
  FONT_SETTINGS: "/fontSettings",
  TEACHER_MESSAGES: "/messages",
  ANNOUNCEMENTS: "/announcements",
  INVOICES: "/payments",
  INVOICE: "/payments/invoice",
  TRAINING: "/training",
  SURVEYS: "/surveys",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CREATE_ACCOUNT: "/create-account",
  SCAN_QR: "/login/scan-qr",
  CLASS_CODE: "/login/class-code",
  NEW_GAMES: "/games",
  FIX_IT_RUSH_GAME: "/games/arcadeGame/fixitrush",
  LISTENING_RACE_GAME: "/games/arcadeGame/listeningrace",
  PREPOSITION_MASTER_GAME: "/games/arcadeGame/phrase-master",
  SENTENCE_SHIFT: "/games/arcadeGame/sentenceshift",
  PHRASE_BUILDER_GAME: "/games/arcadeGame/phrasebuilder",
  WORD_RECALL_CHALLENGE_GAME: "/games/arcadeGame/wordrecallchallenge",
  FLASHCARD_BLITZ_GAME: "/games/arcadeGame/flashcardblitz",
  SENTENCE_SCRAMBLE: "/games/arcadeGame/sentencescramble",
  WORD_MATCH_GAME: "/games/arcadeGame/wordmatch",
  SCENARIO_SNAP: "/games/arcadeGame/scenariosnap",
  MEMORY_PALACE: "/games/arcadeGame/memorypalace",
  WORD_HUNT: "/games/arcadeGame/wordhunt",
  CROSSWORD_QUEST: "/games/arcadeGame/crosswordquest",
  WORD_MAZE: "/games/arcadeGame/wordmaze",
  CONVERSATION_LAB: "/games/arcadeGame/conversationlab",
  TRANSLATION_DUEL: "/games/arcadeGame/translationduel",
}

export const professorRoutes = {
  PROFESSOR_ACCOUNT: "/professor/account",
  PROFESSOR_FEED: "/professor/feed",
  PROFESSOR_MISSIONS: "/professor/missions",
  PROFESSOR_STUDENTS: "/professor/students",
  PROFESSOR_STUDENTS_ADD_OPTIONS: "/professor/students/add/options",
  PROFESSOR_GRADES: "/professor/grades",
  PROFESSOR_GROUPS: "/professor/groups",
}

export const prefixRoutes = {
  PROFESSOR: "/professor",
  EMBED: "/embed",
}
